import HeroBannerAndLogin from "../../../components/public/userLogin/HeroBannerAndLogin";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const PostPropertyLoginPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const location = useLocation();

  if (user) {
    navigate(location.state?.from || "/", { replace: true });
  }

  return <HeroBannerAndLogin />;
};

export default PostPropertyLoginPage;
